module.exports = __webpack_public_path__ + "static/media/siddharth-ooty-trip-01.43bf60a6.png";